// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"3c7ab086","263":"09e2515a","541":"4fb59dce","839":"4fb59dce","941":"344fc770"}[chunkId] + ".chunk.css";
};